<div class="card" style="position: relative">
    <p-toast></p-toast>
    <span class="page-title"><i class="pi pi-gift page-title-icon"></i>Insure Spin and Win</span>
    <p-toast></p-toast>
    <div class="mt-6">
        <p-tabView class="pt-8" (onChange)="onTabChange($event)">
            <p-tabPanel header="Create Promotion">
                <div class="flex-column flex mt-4 ml-3" [formGroup]="createPromoForm">
                    <div class="title-container w-full mb-4 flex align-items-start flex-column gap-2">
                        <h2 style="color: green">Create the promotion to run.</h2>
                        <small style="width: 300px;">Define the promotion you want to run!</small>
                    </div>
                    <div class="promo-info-top">
                        <input placeholder="Promotion Name" type="text" class="create-promo-control"
                            formControlName="name" pInputText />
                    </div>
                    <div class="flex gap-2">
                        <p-calendar formControlName="startDate" [placeholder]="'Select start date'" class="mt-2 "
                            [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                        <p-calendar formControlName="endDate" [placeholder]="'Select end date'" class="mt-2 "
                            [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                    </div>

                </div>
                <div class="flex-column flex gap-1 mt-5 ml-3" [formGroup]="createVoucherForm">
                    <div class="title-container w-full mb-4 flex align-items-start flex-column gap-2">
                        <h2 style="color: green">Create the promotion vouchers.</h2>
                        <small style="width: 300px;">Define vouchers and their quantities and weights</small>
                        @if(promotionVouchers.length > 0){
                        <span class="voucher-count">{{promotionVouchers.length}} vouchers added!</span>
                        }@else {
                        <span class="voucher-count">No vouchers added yet!</span>
                        }
                    </div>
                    <div class="promo-info-top flex flex-column gap-2">
                        <input placeholder="Voucher Name" type="text" class="create-promo-control"
                            formControlName="name" pInputText />
                        <input placeholder="Voucher Amount" type="number" class="create-promo-control"
                            formControlName="amount" pInputText />
                        <input placeholder="Voucher Weight" type="number" class="create-promo-control"
                            formControlName="weight" pInputText />
                    </div>
                    <div class="flex gap-2 row">
                        <button pButton class="mt-4" style="max-width: 200px;" [loading]="savingVoucher"
                            (click)="createNewPromotionVoucher()" [disabled]="createVoucherForm.invalid"
                            severity="primary" label="Save Voucher"></button>
                        <button pButton class="mt-4" style="max-width: 200px;" [loading]="savingPromotion"
                            (click)="createNewPromotion()"
                            [disabled]="createPromoForm.invalid || promotionVouchers.length <2" severity="success"
                            label="Create Promotion"></button>

                    </div>

                </div>
            </p-tabPanel>
            <p-tabPanel header="Run Promotion">
                <div class="spinner-content-container">
                    <div class="spin-form flex justify-content-between w-100">
                        <div class="spin-form-inner ">
                            <div class="title-container w-full mt-4 gap-2 flex align-items-start flex-column ">
                                <h2 style="color: green">Select the promotion period.</h2>
                                <small style="width: 300px;">Load clients, spin the wheel and get a
                                    winner!</small>
                            </div>
                            <div class="date-range-wrapper flex flex-column mt-1 gap-1" [formGroup]="promoForm">
                                <p-calendar formControlName="startDate" [placeholder]="'Select start date'"
                                    [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                                <div class="row">
                                    <p-calendar formControlName="endDate" [placeholder]="'Select end date'"
                                        [iconDisplay]="'input'" class="spin-date" [showIcon]="true"></p-calendar>
                                </div>
                                <div class="row">
                                    <p-dropdown [options]="promotionsList" optionLabel="name"
                                        placeholder="Select Promotion" filter="true" optionValue="id" filterBy="name"
                                        formControlName="promotionId" class="ml-2 spin-promo-dropdown"></p-dropdown>
                                </div>
                                <div class="row">
                                    <p-dropdown [options]="regions" optionLabel="display" optionValue="value"
                                        placeholder="Select Region" formControlName="region"
                                        class="ml-2 spin-promo-dropdown"></p-dropdown>
                                </div>
                                <div class="row mt-2">
                                    <button pButton class="mt-2" [disabled]="promoForm.invalid"
                                        style="max-width: 200px;" [loading]="spinning" (click)="fetchVehicles()"
                                        severity="success" [loading]="runningPromotion" label="Run Promo"></button>

                                    <button pButton class="mt-2 ml-2" style="max-width: 200px;" (click)="reset()"
                                        severity="warning" label="Reset"></button>
                                </div>
                            </div>
                        </div>
                        <div class="wheel-container ml-4">
                            <div class="wheel-wrapper">
                                <canvas #wheel width="600" height="600" class="wheel"
                                    [style.transform]="'rotate(' + currentRotation + 'deg)'"></canvas>
                                <div #pointer class="pointer"></div>
                            </div>
                        </div>

                    </div>
                    <div class="w-100" *ngIf="displayPromoWinner; else noWinner">
                        @if (!runningPromotion){
                        <h5>
                            The Winner Is :<br>
                            {{displayPromoWinner.customerName}} - {{displayPromoWinner.voucher.name}}
                        </h5>
                        <p>Policy Number : <span>{{displayPromoWinner.keyValue}}</span></p>
                        <p>Phone Number : <span>{{displayPromoWinner.mobileNumber}}</span></p>
                        } @else {
                        Getting winner. Stay put...
                        }
                    </div>
                    <ng-template #noWinner>
                        <h6 *ngIf="!spinning">
                            @if (runningPromotion) {
                            Getting winner. Stay put...
                            } @else {
                            Spin the wheel to get a winner!
                            }
                        </h6>
                    </ng-template>
                </div>
            </p-tabPanel>

        </p-tabView>
    </div>

</div>